module.exports = __webpack_public_path__ + "img/Fehlertyp3_Dok2.75cfb8f9.jpg";